import type { FC, PropsWithChildren } from 'react';
import { cn } from '@/app/utils';

const DividerSVG = ({ width = '440', height = '1', stopColor = 'white' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 440 1"
    preserveAspectRatio="none"
    fill="none"
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 1V0L440 0.666667L0 1Z" fill="url(#paint0_linear_872_59152)" />
    <defs>
      <linearGradient id="paint0_linear_872_59152" x1="0" y1="0.5" x2="440" y2="0.5" gradientUnits="userSpaceOnUse">
        <stop stopColor="currentColor" />
        <stop offset="0.68" stopColor={stopColor} stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const Divider: FC<
  PropsWithChildren<{
    className?: string;
  }>
> = ({ children, className }) => {
  return (
    <div className={cn('flex items-center justify-center text-[rgba(255,255,255,.45)]', className)}>
      <div className="rotate-180">
        <DividerSVG width="100%" />
      </div>
      {children}
      <div>
        <DividerSVG width="100%" />
      </div>
    </div>
  );
};
